<template>
  <div class="col loader p-5" :style="{ height, width: computedWidth }">
    <div class="logo"></div>
    <div class="sk-spinner sk-spinner-three-bounce">
      <div class="loadball sk-bounce1"></div>
      <div class="loadball sk-bounce2"></div>
      <div class="loadball sk-bounce3"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: `SkeletonBox`,
  props: {
    maxWidth: {
      default: 100,
      type: Number,
    },
    minWidth: {
      default: 80,
      type: Number,
    },
    height: {
      default: `1em`,
      type: String,
    },
    width: {
      default: null,
      type: String,
    },
  },
  computed: {
    computedWidth() {
      return this.width || `${Math.floor((Math.random() * (this.maxWidth - this.minWidth)) + this.minWidth)}%`;
    },
  },
};
</script>
